<template>
  <SuccessChip v-if="actualKind === 'applied'">Вы откликнулись</SuccessChip>
  <BasicButton
    v-else-if="actualKind === 'guest'"
    :href="`/users/auth/tmid/register_for_response/${vacancyId}`"
    appearance="primary"
    size="m"
    rel="noindex,nofollow"
  >
    Откликнуться
  </BasicButton>
  <BasicButton
    v-else-if="actualKind === 'page'"
    :href="`/vacancies/${vacancyId}/#create-vacancy-response`"
    appearance="primary"
    size="m"
  >
    Откликнуться
  </BasicButton>
  <BasicButton
    v-else
    appearance="primary"
    size="m"
    @click="applyToVacation"
    type="button"
  >
    Откликнуться
  </BasicButton>
</template>

<script>
import { defineComponent, ref } from 'vue';

import { notify } from 'src/notify.js';
import { handleRequestError } from 'src/services/api.js';
import { VacanciesResponsesResource } from 'src/services/vacancies.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import SuccessChip from 'src/components/SuccessChip/SuccessChip.vue';

export default defineComponent({
  name: 'VacancyResponseFromCard',
  components: {
    BasicButton,
    SuccessChip,
  },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    kind: {
      type: String,
      required: true,
      validator(value) {
        return ['applied', 'direct', 'page', 'guest'].includes(value);
      },
    },
  },
  setup(props) {
    const actualKind = ref(props.kind);
    async function applyToVacation() {
      try {
        actualKind.value = 'applied';
        await VacanciesResponsesResource.post({
          vacancyId: props.vacancyId,
          data: {
            source: 'vacancies_list',
          },
        });
      } catch (error) {
        actualKind.value = 'direct';
        const messageFromResponse = error?.response?.data?.message;

        if (messageFromResponse) {
          notify({
            message: messageFromResponse,
            type: 'error',
          });
          return;
        }

        handleRequestError(error);
      }
    }

    return { applyToVacation, actualKind };
  },
});
</script>
